import React, { useContext } from "react";
import { LocationContext } from "./context";

const LocationDebug = () => {
  const { activeLocation } = useContext(LocationContext);
  return <pre>{JSON.stringify(activeLocation, null, 2)}</pre>;
};

export default LocationDebug;
